import React from "react";

const noopur_karkare = () => {
  return (
    <div>
      <h1>Noopur Karkare</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students from computer,entc and robotics\&amp;AI with a CGPA limit of 8
        were eligible for the aptitude test
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        1) Online aptitude test on 30th july
        <br />
        2) Interviews in the placement cell on 31st july
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude test consisted of questions based on math,java code
        snippets, core cs subjects like DBMS,OOPD,OS and then some questions
        about the company as we were intimated before.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        31 students were shortlisted after the first round . On the day of
        interviews they released another shortlist with a subset of 12 students
        out of the 31 and added 4 to it later in the day .
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was released in the evening and the interviews were
        scheduled for the next day. I had read about the interviews of past year
        students for IDEAS on TY diaries so I was well aware that they focus on
        the projects. I had three projects on my resume so I focused on their
        implementations and intricacies the day before.I had my summer
        internship mentioned as well so I made sure to go through it once . I
        also searched more about the company and had decided the questions I
        wanted to ask the interviewers given a chance to know more and show more
        curiosity. I later revised through the core topics from the notes I had
        made for subjects like DSA,OOPD,CN and DBMS.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        Round 1: Technical Interview (45 mins)
        <br />
        There were two panels with three interviewers each . I introduced myself
        and the various projects and internships mentioned on the resume and
        also the clubs and fests that I was a part of.
        <br />
        My technical round was based entirely upon my summer internship. It was
        in the domain of software development. It was more of an interesting
        discussion about the implementations therein. I was asked to explain the
        schema used , practical applications and hypothetical scenarios based on
        them. The main intention was to observe the way I proposed solutions and
        my way of thinking and not just the accuracy of proposed solutions.
        Another panel even asked a candidate to show a git repository but
        everyone was asked about the projects and practical implementations more
        than theoretical concepts alone. To end the interview they asked me if I
        had any questions for them so I was able to ask the question I had
        decided earlier.
        <br />4 students were shortlisted for the HR round.
      </p>

      <p>
        Round 2: HR round (40 mins)
        <br />
        This round started off with questions about my family background, my
        favourite subjects growing up and general behavioural questions. I made
        sure to correlate my scenario based answers with my experience in
        Mindspark and the cultural club and also regatta.I made sure to mention
        the social internship as well.I was asked a puzzle towards the end. The
        approach mattered the most . Out of the 4, 3 students were selected for
        the offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        For the technical round the practical questions that I was asked were
        heavily upon DBMS concepts and it was entirely based upon the project in
        discussion for everyone.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Striver’s A to Z sheet for DSA , Love babbar for OS and DBMS and Gate
        Smashers for CN.
        <br />
        Leetcode and Indiabix as platforms for problem solving.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practicing enough is the only way out and understanding more than
        completing all topics in a rush .
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        As mentioned earlier, projects were the main source of discussion and I
        just made sure to mention my participation in clubs and the technical
        fest during the HR round.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Showing genuine interest in the project that you have done yourself and
        presenting yourself to be inquisitive enough helps a ton. The way you
        present yourself and answer is important .
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Self confidence is necessary during the interviews and if you are not
        aware of a certain answer, make sure to admit it without bluffing
        unnecessarily. Try to look at the interview as a conversation to discuss
        subjects that genuinely matter to you . The entire process can feel very
        overwhelming having so many companies approaching in a very short amount
        of time with probably no time to fix the previous mistakes, but trust
        the process and everything will work out!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> +91 97637 18189
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:karkarena23.comp@coeptech.ac.in">
          karkarena23.comp@coeptech.ac.in
        </a>
        <br />
      </p>
    </div>
  );
};

export default noopur_karkare;
